import { useMemo } from 'react';

import {
  DISCUSSION_STATUS_REJECTED,
  DISCUSSION_STATUS_UNMODERATED,
  DiscussionStatus as DiscussionStatusType,
  DiscussionStatusTag,
} from '~/lib/discussions/types';
import { DiscussionStatusItem } from './DiscussionStatusItem';

interface DiscussionState {
  isApproved: boolean | null | undefined;
  isResolved: boolean | undefined;
  discussionStatus?: DiscussionStatusType;
}

export default function DiscussionStatus({
  isApproved,
  isResolved,
  discussionStatus,
}: DiscussionState) {
  const status: DiscussionStatusTag = useMemo(() => {
    if (
      discussionStatus === DISCUSSION_STATUS_UNMODERATED ||
      (typeof discussionStatus === 'undefined' &&
        typeof isApproved === 'undefined') ||
      isApproved === null
    ) {
      return { text: 'Pending Moderation', className: 'bg-sunset' };
    }

    if (
      discussionStatus === DISCUSSION_STATUS_REJECTED ||
      (typeof discussionStatus === 'undefined' && !isApproved)
    ) {
      return { text: 'Denied', className: 'bg-ready-red' };
    }

    return { text: '', className: '' };
  }, [discussionStatus, isApproved]);

  if (isResolved && !status.text) {
    return <></>;
  }

  return (
    <div className="flex gap-2">
      {status.text && (
        <DiscussionStatusItem text={status.text} className={status.className} />
      )}
      {!isResolved && (
        <DiscussionStatusItem text="Unresolved" className="bg-entrepurple" />
      )}
    </div>
  );
}
